import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { loadingBus } from '../../utils/loadingBus';

const GlobalLoader: React.FC = () => {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    const unsubscribe = loadingBus.subscribe(setCount);
    return unsubscribe;
  }, []);

  return (
    <Backdrop open={count > 0} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoader;